import { TweenLite, Power3, Power4, TimelineLite } from 'gsap'
import { addClass, removeClass, supportsWebGL } from '../utilities'
import Background from './background'
//import { onResize } from '../utilities'
import * as VARS from '../variables'

const TECHNIQUES = [
    'Web scraping for insights',
    'Computer generated variations',
    'Real-time design on devices',
    'WYSIWYG interaction design',
    'Truly rapid prototyping',
    'Interactive documentation',
    'Multi-variant testing'
];

const HIDE_HINT_CLASS = 'hide-hint';

export default class
{
    constructor( el, accentColor ){
        this.el = el;

        let height = Math.floor(window.innerHeight / 16) * 16;
        el.style.height = Math.max(VARS.MIN_HOME_HEIGHT, (height - VARS.BASELINE*VARS.NEXT_SECTION_HINT_ROWS)) + 'px';

        if( supportsWebGL() ){
            this.background = new Background( el, accentColor );
        }

        this.el.querySelector( '.next' ).style.color = accentColor;
        this.el.querySelector( 'h3' ).style.color = accentColor;

        this.setupTechniques();
        this.compose();

        this.__showScrollHint = true;

        document.addEventListener('scroll', this.didScroll.bind(this) );
        this.didScroll();
    }

    set showScrollHint( v ){
        if( v === this.__showScrollHint ){
            return;
        }
        this.__showScrollHint = v;
        if( v ){
            removeClass( this.el, HIDE_HINT_CLASS );
        }else{
            addClass( this.el, HIDE_HINT_CLASS );
        }
    }

    get showScrollHint() {
        return this.__showScrollHint;
    }

    didScroll()
    {
        //console.log(' HOME: ' + document.body.scrollTop );
        this.showScrollHint = ( document.body.scrollTop < window.innerHeight*0.2 );
    }

    compose()
    {
        let items = [];
        items.push( this.el.querySelector( 'h1' ) );
        items.push( this.el.querySelector( 'p' ) );
        items.push( this.el.querySelector( 'h3' ) );
        items.push( this.el.querySelector( 'ul' ) );

        let tl = new TimelineLite();
        tl.staggerFrom( items, 1.2, {
            opacity: 0,
            y: '+' + 120,
            ease: Power4.easeOut
        }, 0.1, 0.5);
    }

    setupTechniques()
    {
        this.techniqueIndex = 0;
        this.techniquesContainer = this.el.querySelector('div.techniques ul');
        this.topTechnique = this.techniquesContainer.appendChild( document.createElement( 'li' ) );
        this.bottomTechnique = this.techniquesContainer.appendChild( document.createElement( 'li' ) );


        this.topTechnique.innerHTML = TECHNIQUES[ this.techniqueIndex ];
        this.bottomTechnique.innerHTML = TECHNIQUES[ (this.techniqueIndex+1) % TECHNIQUES.length ];
        this.bottomTechnique.style.visibility = 'hidden';

        setTimeout( this.showNextTechnique.bind(this), 3000 );
    }

    showNextTechnique()
    {
        if( document.hidden ){
            setTimeout( this.showNextTechnique.bind(this), 3000 );
            return;
        }
        this.bottomTechnique.style.visibility = 'visible';

        let duration = 1;
        let ease = Power3.easeInOut;

        TweenLite.to( this.topTechnique, duration, {
            opacity: 0,
            ease
        });
        TweenLite.from( this.bottomTechnique, duration, {
            opacity: 0,
            ease
        });
        TweenLite.to( this.techniquesContainer, duration, {
            rotationX: 90,
            transformOrigin: '0 16px',
            ease,
            onComplete: () => {
                this.techniqueIndex++;
                this.topTechnique.innerHTML = TECHNIQUES[ this.techniqueIndex % TECHNIQUES.length ];
                this.bottomTechnique.innerHTML = TECHNIQUES[ (this.techniqueIndex+1) % TECHNIQUES.length ];
                this.bottomTechnique.style.visibility = 'hidden';

                TweenLite.set( this.topTechnique, {
                    opacity: 1
                });

                TweenLite.set( this.techniquesContainer, {
                    rotationX: 0,
                    transformOrigin: '0 16px'
                });

                setTimeout( this.showNextTechnique.bind(this), 3000 );
            }
        });
    }
}


/** WEBPACK FOOTER **
 ** ./src/js/home/home.js
 **/